import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Fade + rise on scroll into view
export const Reveal = ({ children, delay = 0, y = 32, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-90px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

// Staggered container + item
export const StaggerGroup = ({ children, className = "", stagger = 0.09 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-80px" }}
    variants={{ hidden: {}, show: { transition: { staggerChildren: stagger } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 36 }) => (
  <motion.div
    className={className}
    variants={{ hidden: { opacity: 0, y }, show: { opacity: 1, y: 0, transition: { duration: 0.75, ease: EASE } } }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal (for hero headlines)
export const MaskLines = ({ lines, className = "", delay = 0, lineDelay = 0.12 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className="block"
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.95, delay: delay + i * lineDelay, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

// Simple fade-in with delay (for hero sub-content)
export const FadeIn = ({ children, delay = 0, y = 18, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);
